export default __webpack_public_path__ + "static/media/terminal-ico.e7db1465.svg";